import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
} from '@material-ui/core';
import DialogButtons from 'ui/dialog/Buttons';
import ButtonsForm from 'ui/form/ButtonsForm';
import { MethodForm } from './MethodForm';
import { AuthForm } from './AuthForm';
import { TOTPForm } from './TOTPForm';
import { initVerify2FA, verify2FA } from '../../service';

export const SetupDialog = ({ onSubmit, onCancel, onUpdate, open, data }) => {
    const [confirmCode, setConfirmCode] = useState(data.confirm_code);
    const [values, setValues] = useState({});
    const [error, setError] = useState(false);
    const [step, setStep] = useState(0);
    const [loading, setLoading] = useState(false);

    const handleMethodChange = event => {
        setValues({ ...values, method: event.target.value });
    };

    const handleNext = async () => {
        setLoading(true);
        if (step === 0) {
            switch (values.method) {
                case 'sms':
                    setStep(1);
                    break;
                case 'totp':
                    const initData = await initVerify2FA({
                        type: values.method,
                        confirmCode,
                    });
                    setConfirmCode(initData.confirm_code);
                    setValues({
                        ...values,
                        mfa_code: initData.code,
                        qr: initData.qr,
                    });
                    setStep(2);
                    break;
                default:
                    break;
            }
        } else {
            setError(false);
            try {
                const verifyData = await verify2FA({
                    code: values.code,
                    confirmCode,
                });
                if (verifyData && verifyData.status === 'error') {
                    return handleAuthError(verifyData.confirm_code);
                }
                onUpdate({ type: values.method, enabled: true });
                onSubmit(verifyData);
            } catch {
                return handleAuthError();
            }
        }
        setLoading(false);
    };

    const handleAuthError = confirmCode => {
        setError(true);
        setValues({ ...values, code_sended: false, phone: '', code: '' });
        if (confirmCode) {
            setConfirmCode(confirmCode);
        }
        setLoading(false);
    };

    const handleSendCode = async () => {
        setError(false);
        try {
            const initData = await initVerify2FA({
                type: values.method,
                phone: values.phone,
                confirmCode,
            });
            if (initData && initData.confirm_code) {
                setValues({ ...values, code_sended: true });
                setConfirmCode(initData.confirm_code);
            }
            return true;
        } catch {
            setValues({ ...values, code_sended: false, code: '', phone: '' });
            setError(true);
            return false;
        }
    };

    const isDisabled = () => {
        switch (step) {
            case 0: {
                return !values.method;
            }
            case 1: {
                return !values.phone || !values.code;
            }
            case 2: {
                return !values.code;
            }
            default:
                break;
        }
    };

    return (
        <Dialog open={open} fullWidth>
            <DialogTitle>
                {step === 2
                    ? 'Scan this barcode with your app'
                    : 'Enable two-step verification'}
                {error && step !== 2 && (
                    <Typography variant="body2" color="error">
                        Two-factor code verification code failed. Please try
                        again
                    </Typography>
                )}
            </DialogTitle>
            <DialogContent>
                {step === 0 && (
                    <MethodForm values={values} onChange={handleMethodChange} />
                )}
                {step === 1 && (
                    <AuthForm
                        values={values}
                        onSendCode={handleSendCode}
                        onChange={value => setValues({ ...values, ...value })}
                    />
                )}
                {step === 2 && (
                    <TOTPForm
                        values={values}
                        error={error}
                        onChange={value => setValues({ ...values, ...value })}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <DialogButtons>
                    <ButtonsForm.BackButton label="Cancel" onClick={onCancel} />
                    <ButtonsForm.NextButton
                        label={step === 0 ? 'Next' : 'Enable'}
                        onClick={handleNext}
                        loading={loading}
                        disabled={isDisabled()}
                    />
                </DialogButtons>
            </DialogActions>
        </Dialog>
    );
};
